import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { KieneTableService } from '../../../../../../../../src/app/components/kiene-table/kiene-table.service';
import { API_BASE_URL_SERVICE } from '../../../../kiene-core.config';
import { AppService } from '../../../../services/app/app.service';
import { Gruppe } from '../../classes/gruppe';
import { GruppeBewegung } from '../tod-melden-dialog/tod-melden-dialog';
import { MessageService } from '../../../../services/message-service/message.service';

@Component({
    selector: 'kiene-schweine-ausstallen-dialog',
    templateUrl: './ausstallen-dialog.component.html',
    styleUrls: ['./ausstallen-dialog.component.scss'],
})
export class AusstallenDialogComponent implements OnInit {
    anzahlTiereCtrl: FormControl = new FormControl(undefined, [Validators.required, Validators.min(1)]);
    ausstalldatumCtrl: FormControl = new FormControl(undefined, [Validators.required]);
    ausstallgewichtProTierCtrl = new FormControl();
    futtermengeProTierCtrl = new FormControl();
    futtermengeGesamtCtrl = new FormControl();
    isSaving = false;
    isMobile = false;

    constructor(
        public dialogRef: MatDialogRef<AusstallenDialogComponent>,
        @Inject(MAT_DIALOG_DATA) protected gruppe: Gruppe,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        private messageService: MessageService,
        private api: KieneTableService,
        private appService: AppService,
    ) {}

    ngOnInit(): void {
        this.isMobile = this.appService.isMobileScreen;
        if (this.gruppe.anzahl_tiere) {
            this.anzahlTiereCtrl.setValue(this.gruppe.anzahl_tiere);
        }
        this.futtermengeProTierCtrl.valueChanges.subscribe({
            next: value => {
                if (value && this.anzahlTiereCtrl.value) {
                    const gew = Math.round(value * this.anzahlTiereCtrl.value * 100) / 100;
                    this.futtermengeGesamtCtrl.setValue(gew, { emitEvent: false });
                }
            },
        });

        this.futtermengeGesamtCtrl.valueChanges.subscribe({
            next: value => {
                if (value && this.anzahlTiereCtrl.value > 0) {
                    const gew = Math.round((value / this.anzahlTiereCtrl.value) * 100) / 100;
                    this.futtermengeProTierCtrl.setValue(gew, { emitEvent: false });
                }
            },
        });

        this.anzahlTiereCtrl.valueChanges.subscribe({
            next: value => {
                if (value) {
                    if (this.futtermengeProTierCtrl.value > 0) {
                        const futter = Math.round(value * this.futtermengeProTierCtrl.value * 100) / 100;
                        this.futtermengeGesamtCtrl.setValue(futter, { emitEvent: false });
                    }
                }
            },
        });
    }

    public save(): void {
        this.isSaving = true;
        const data = new GruppeBewegung();
        data.gruppe_id = this.gruppe.gruppe_id;
        data.anzahl_tiere = this.anzahlTiereCtrl.value;
        data.datum = this.ausstalldatumCtrl.value;
        data.ausstallgewicht = this.ausstallgewichtProTierCtrl.value;
        data.futtermenge = this.futtermengeProTierCtrl.value;
        data.an_hit_melden = 0;
        data.bewegung_typ = 2;

        this.api.post(this.apiBaseUrl + 'gruppe_bewegung/update.php', data).subscribe({
            next: () => {
                this.dialogRef.close(true);
            },
            error: err => {
                this.isSaving = false;
                this.messageService.errorMessage('Ausstallen fehlgeschlagen!', err);
            },
        });
    }

    public isDisabled(): boolean {
        return this.anzahlTiereCtrl.invalid || this.ausstalldatumCtrl.invalid || this.isSaving;
    }
}
